import { createApi } from '@reduxjs/toolkit/query/react';
import { bffBaseQuery } from './utils/base-queries-with-error-handling';

export enum TagTypes {
  AccessGroup = 'AccessGroup',
  AccessGroupAssets = 'AccessGroupAssets',
  MachineUsageGraphData = 'MachineUsageGraphData',
  MachineUsageTotalData = 'MachineUsageTotalData',
  ProductTechnicalInformation = 'ProductTechnicalInformation',
  UsersAndInvites = 'UsersAndInvites',
  User = 'User',
  AccountSettings = 'AccountSettings',
  UserMapSettings = 'UserMapSettings',
  MachineAreaDetails = 'MachineAreaDetails',
  Dashboard = 'Dashboard',
  AssetList = 'AssetList',
  AssetListItem = 'AssetListItem',
  AssetMap = 'AssetMap',
  GKTLogActivities = 'GKTLogActivities',
  GKTTasks = 'GKTTasks',
  GKTCalibratedHeight = 'GKTCalibratedHeight',
  GKTActivityClusters = 'GKTActivityClusters',
  GKTGrassGrowthPredictions = 'GKTGrassGrowthPredictions',
  SignupFormSetup = 'SignupFormSetup',
  Invite = 'Invite',
  DealerAccess = 'DealerAccess',
  AssetTags = 'AssetTags',
  AssetTagSuggestions = 'AssetTagSuggestions',
  FilterOptions = 'FilterOptions',
  FilterOptionsTags = 'FilterOptionsTags',
  GatewayDeviceList = 'GatewayDeviceList',
}

export const bffWebApi = createApi({
  baseQuery: bffBaseQuery,
  endpoints: () => ({}),
  tagTypes: [
    TagTypes.MachineUsageGraphData,
    TagTypes.MachineUsageTotalData,
    TagTypes.AccessGroup,
    TagTypes.AccessGroupAssets,
    TagTypes.AccessGroupAssets,
    TagTypes.UsersAndInvites,
    TagTypes.User,
    TagTypes.AccountSettings,
    TagTypes.UserMapSettings,
    TagTypes.MachineAreaDetails,
    TagTypes.ProductTechnicalInformation,
    TagTypes.Dashboard,
    TagTypes.AssetList,
    TagTypes.AssetListItem,
    TagTypes.AssetMap,
    TagTypes.GKTLogActivities,
    TagTypes.GKTTasks,
    TagTypes.GKTCalibratedHeight,
    TagTypes.GKTActivityClusters,
    TagTypes.GKTGrassGrowthPredictions,
    TagTypes.SignupFormSetup,
    TagTypes.Invite,
    TagTypes.DealerAccess,
    TagTypes.AssetTags,
    TagTypes.AssetTagSuggestions,
    TagTypes.FilterOptions,
    TagTypes.FilterOptionsTags,
    TagTypes.GatewayDeviceList,
  ],
});
